import i18next from 'i18next';
import backend from 'i18next-http-backend';
import {initReactI18next} from 'react-i18next';
import I18nextBrowserLanguageDetector from 'i18next-browser-languagedetector';
import {i18nSupportedLangCodes} from '../../Common/i18n/i18nLanguages';
import {Sentry} from '../../Core/sentry';
import {createVersionedLoadPath} from '../../Common/i18n/i18nVersions';

// these namespace are needed for jquery-views to access i18n-texts. In our react-world, we don't need to mention any namespaces here
const namespaces: string[] = ['FroalaTextEditors'];

// we need to store failed files here so we dont send the errors to sentry in those cases
const failedFiles: string[] = [];

i18next
  // load translation using xhr -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  // learn more: https://github.com/i18next/i18next-xhr-backend
  .use(backend)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  .use(I18nextBrowserLanguageDetector) // {load:'languageOnly'}
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    load: 'languageOnly',
    ns: ['common', 'Errors', ...namespaces],
    fallbackNS: ['common', 'Errors'],
    fallbackLng: ['de'],
    supportedLngs: i18nSupportedLangCodes,
    saveMissing: true, // required for 'missingKeyHandler' to be triggered
    missingKeyHandler(lngs: readonly string[], namespace: string, key: string): void {
      const filename = `i18n.${lngs}.${namespace}.json`;
      if (failedFiles.includes(filename)) return;
      Sentry.captureException(new Error(`App - i18n-Translations: Missing key: ${key} (in ${filename})`));
    },

    debug: false,
    backend: {
      loadPath: createVersionedLoadPath('/assets/lamapoll/i18n'),
    },
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    react: {
      useSuspense: true,
      // wait        : true
    },
    // the detected language is cached in localStorage by the detector's default (caches: ['localStorage'])
    detection: {
      order: ['htmlTag', 'localStorage', 'path', 'navigator'],
      lookupFromPathIndex: 1,
    },
  });

i18next.on('failedLoading', (lng: string, ns: string) => failedFiles.push(`i18n.${lng}.${ns}.json`));

export const i18n = i18next;
